// extracted by mini-css-extract-plugin
export default {"text":"Forms_text__OXkQ-","head":"Forms_head__2D+AX","submit":"Forms_submit__+o1IY"};